import { render, staticRenderFns } from "./RadioLightBox.vue?vue&type=template&id=6a74f4ee&"
import script from "./RadioLightBox.vue?vue&type=script&lang=js&"
export * from "./RadioLightBox.vue?vue&type=script&lang=js&"
import style0 from "./RadioLightBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports